var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-fixed-panel"},[_c('div',{staticClass:"fixed-content"},[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"action-item",on:{"click":_vm.scrollToTop}},[_vm._m(0),_c('span',{staticClass:"action-text"},[_vm._v(" TOP ")])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-icon"},[_c('i',{staticClass:"el-icon-caret-top"})])
}]

export { render, staticRenderFns }